$(document).ready(function(){

    function ifVisible(element, buffer) {
        var top_of_element = $(element).offset().top;
        var bottom_of_element = $(element).offset().top + $(element).outerHeight();
        var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        var top_of_screen = $(window).scrollTop();
        var buffer_from_bottom = buffer ? ($(window).outerHeight() / 5) : 0;

        if( (bottom_of_screen - buffer_from_bottom > top_of_element) && (top_of_screen < bottom_of_element) ){
            return true;
        } else {
            return false;
        }
    }

    function ifVisibleFadeIn(element, hide, buffer) {
        var wrapper = $(element).closest('section').first()[0];

        if( $(wrapper).hasClass('block-text-text') && $(wrapper).hasClass('bg-green-dark-partial') )
            buffer += 1500;

        if( ifVisible(wrapper, buffer) ){

            if( $(wrapper).hasClass('block-text-text') && $(wrapper).hasClass('bg-green-dark-partial') ) {

                if( $(wrapper).css('bottom') !== 0 ) {
                    // $(element).animate({
                    //     bottom: 0
                    // }, 1500);

                    $(element).addClass('slide slide-from-bottom');
                }

            } else {
                if( $(wrapper).css('opacity') !== 1 ) {

                    $(element).animate({
                        opacity: 1
                    }, 500);
                }
            }

        } else {
            if( !$(wrapper).hasClass('block-text-text') && !$(wrapper).hasClass('bg-green-dark-partial') ) {

                if( hide && $(element).css('opacity') != 0 ) {
                    $(element).css({
                        opacity: 0
                    });
                }
            }
        }
    }

    $('main').each(function(){
        $(this).animate({
            opacity: 1
        }, 500);
    })

    $('section .container .col-12').each(function(){
        ifVisibleFadeIn(this, true, false);
    })

    $(window).scroll(function() {
        $('section .container .col-12').each(function(){
            ifVisibleFadeIn(this, false, true);
        })

        $('.block-img-text').each(function(){
            var imgCol = $(this).find('.col-img').first();

            if( ifVisible(imgCol, true, false) ) {
                imgCol.addClass('slide-in');
            }
        });
    });

    $(document).keyup(function(e) {
        var code = e.keyCode || e.which;

        if (code === 9) {

            $('section .container .col-12').each(function(){
                ifVisibleFadeIn(this, false, true);
            })

            $('.block-img-text').each(function(){
                var imgCol = $(this).find('.col-img').first();

                if( ifVisible(imgCol, true, false) ) {
                    imgCol.addClass('slide-in');
                }
            });

            if( $(e.target).parent().hasClass('cta-wrapper') &&
                $(e.target).closest('section').hasClass('block-text-text') &&
                $(e.target).closest('section').hasClass('bg-green-dark-partial') &&
                $(e.target).parent().parent().css('bottom') !== 0) {
                    $(e.target).parent().parent().animate({
                        bottom: 0
                    }, 1500);

                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(e.target).closest('section').offset().top
                    }, 1500);
            }
        }
    })
})
